import React from 'react'
import 'react-multi-carousel/lib/styles.css';
import { Slide } from "react-awesome-reveal";


function HomeServices() {
  return (

    <section className='py-12 bg-black ' id="services">

      <div className=' text-center mb-8'>
        <h2 className="text-3xl font-bold text-white">Nos services, conçus pour vous offrir le meilleur</h2>
      </div>
      <Slide delay={200} duration={2500}>
        <div className="w-full flex justify-center my-[8em]">
          <div className='text-center grid grid-cols-1 md:grid-cols-4 gap-4'>

            <div class="max-w-sm  rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
              <a href="#">
                <img class="rounded-t-lg" src={`${process.env.PUBLIC_URL}/images/quais-surpoteaux.jpg`} alt="Quais sur poteaux" />
              </a>

              <div className="relative p-5 bg-white overflow-hidden rounded-b-lg transition-all duration-300 group">
                <div className="absolute inset-0 bg-cyan-500 scale-y-0 origin-top transition-transform duration-300 group-hover:scale-y-100" />
                <div className="relative z-10">
                  <a href="#">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 group-hover:text-white">
                      Quais sur poteaux
                    </h5>
                  </a>
                  <p className="mb-3 font-normal text-gray-700 group-hover:text-white">
                    Quais sur poteaux et accessoires en tout genre
                  </p>
                </div>
              </div>
            </div>


            <div class="max-w-sm  border-gray-200 rounded-lg shadow-sm">

              <div className="relative p-5 bg-white overflow-hidden rounded-t-lg  transition-all duration-500 group">
                <div className="absolute inset-0 bg-cyan-500 scale-y-0 origin-bottom transition-transform duration-500 group-hover:scale-y-100" />
                <div className="relative z-10">
                  <a href="#">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 group-hover:text-white">
                      Quais flottants
                    </h5>
                  </a>
                  <p className="mb-3 font-normal text-gray-700 group-hover:text-white">
                    Pour vos projets flottants résidentiels ou commerciaux.
                  </p>
                </div>
              </div>
              <a href="#">
                <img class="rounded-b-lg" src={`${process.env.PUBLIC_URL}/images/quais-flottants.jpg`} alt="Pour vos projets flottants résidentiels ou commerciaux" />
              </a>
            </div>

            <div class="max-w-sm rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">

              <img class="rounded-t-lg max-h-[172px] w-full" src={`${process.env.PUBLIC_URL}/images/acces-lac.jpg`} alt="Accès au lac" />


              <div className="relative p-5 bg-white overflow-hidden rounded-b-lg transition-all duration-300 group">
                <div className="absolute inset-0 bg-cyan-500 scale-y-0 origin-top transition-transform duration-300 group-hover:scale-y-100" />
                <div className="relative z-10">
                  <a href="#">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 group-hover:text-white">
                      Accès au lac
                    </h5>
                  </a>
                  <p className="mb-3 font-normal text-gray-700 group-hover:text-white">
                    Pour un accès propre et sécuritaire a votre plan d’eau
                  </p>
                </div>
              </div>
            </div>


            <div class="max-w-sm rounded-lg shadow-sm">

              <div className="relative p-5 bg-white overflow-hidden rounded-t-lg transition-all duration-500 group">
                <div className="absolute inset-0 bg-cyan-500 scale-y-0 origin-bottom transition-transform duration-500 group-hover:scale-y-100" />
                <div className="relative z-10">
                  <a href="#">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 group-hover:text-white">
                      Au-dessus de l’eau
                    </h5>
                  </a>
                  <p className="mb-3 font-normal text-gray-700 group-hover:text-white">
                    Entreposer vos investissements au-dessus de l’eau durant l’hiver
                  </p>
                </div>
              </div>
              <a href="#">
                <img class="rounded-b-lg" src={`${process.env.PUBLIC_URL}/images/quais-audessud-deleau.jpg`} alt=" Entreposer vos investissements au-dessus de l’eau durant l’hiver" />
              </a>
            </div>

            <div class="max-w-sm  rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
              <a href="#">
                <img class="rounded-t-lg" src={`${process.env.PUBLIC_URL}/images/all.jpg`} alt="De tout pour vous!" />
              </a>

              <div className="relative p-5 bg-white overflow-hidden rounded-b-lg transition-all duration-300 group">
                <div className="absolute inset-0 bg-cyan-500 scale-y-0 origin-top transition-transform duration-300 group-hover:scale-y-100" />
                <div className="relative z-10">
                  <a href="#">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 group-hover:text-white">
                      De tout pour vous!
                    </h5>
                  </a>
                  <p className="mb-3 font-normal text-gray-700 group-hover:text-white">
                    Vos projets hors standards , nos solutions sur mesures
                  </p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </Slide>
    </section>

  )
}

export default HomeServices